import { outlinedInputClasses } from '@mui/material'
import StylesTextFieldServiceInterface
  from '~/src/components/mui-wrappers/styled/text-field/styles/StylesTextFieldServiceInterface'
import TemplateServiceStyleBase from '~/src/utils/template/TemplateServiceStyleBase'

export default class StylesTextFieldServiceStyleThree extends TemplateServiceStyleBase implements StylesTextFieldServiceInterface {
  public getComponentSx(): Record<string, unknown> {
    return {
      [`.${outlinedInputClasses.root}`]: {
        borderRadius: '1em',
        backgroundColor: this.muiTheme.palette.getContrastText(this.muiTheme.palette.text.primary)
      },
      '& > p': {
        textAlign: 'right'
      }
    }
  }
}
